import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Import PrimeReact CSS
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import './styles/main.css';
import { BlocAppWrapper } from './ui/bloc/BlocAppWrapper';
import AppWrapper from './ui/components/AppWrapper';
import { PrimeReactProvider } from 'primereact/api';

// Khởi tạo BlocAppWrapper instance toàn cục - tương tự module-ui
const blocAppWrapper = new BlocAppWrapper();

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <PrimeReactProvider>
            <BrowserRouter>
                <AppWrapper blocAppWrapper={blocAppWrapper} />
            </BrowserRouter>
        </PrimeReactProvider>
    </React.StrictMode>
);
